import { useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

const navLinks = [
  { to: '/about', label: 'About the Ship' },
  { to: '/gallery', label: 'Photo Gallery' },
  { to: '/charters', label: 'For Charters' },
  { to: '/alumni', label: 'Alumni, Family, Friends' },
  { to: '/contact', label: 'Contact' },
]

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  // close drawer on navigation
  const close = () => setMenuOpen(false)

  return (
    <div id="wrapper">
      <div className="bg-wrapper">
        <div id="header">
          <div id="sitename">
            <NavLink to="/" onClick={close}>
              <img
                src="/assets/uploads_1_2_8_8_12888984_2152789.png"
                alt="ALAMAR - traditional wooden schooner sailing the coast of Maine"
              />
            </NavLink>
          </div>
        </div>

        {/* Desktop nav */}
        <nav id="navigation" className="desktop-nav">
          <div className="nav-inner">
            <span className="nav-line" />
            <ul className="nav-items">
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    className={({ isActive }) => isActive ? 'active' : undefined}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <span className="nav-line" />
          </div>
        </nav>

        {/* Mobile nav */}
        <div className="mobile-nav">
          <button
            className="hamburger"
            onClick={() => setMenuOpen(o => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
              <span /><span /><span />
            </span>
          </button>

          {menuOpen && (
            <div className="mobile-drawer">
              <button className="drawer-close" onClick={close} aria-label="Close menu">
                &times;
              </button>
              <ul>
                {navLinks.map(({ to, label }) => (
                  <li key={to}>
                    <NavLink
                      to={to}
                      className={({ isActive }) => isActive ? 'active' : undefined}
                      onClick={close}
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div id="content-wrapper">
          <div id="content">
            <Outlet />
          </div>
        </div>
      </div>

      <div id="footer">
        <div id="footer-content" />
      </div>
    </div>
  )
}
